<template>
  <div class="exclusive-container">
    <v-row class="px-0 mb-6" no-gutters>
      <v-col cols="12">
        <div class="d-flex align-end justify-space-between section-header-wrap">
          <div class="header-left d-flex flex-column align-start">
            <div class="premium-badge mb-1">
              <v-icon left size="14" color="#3EA56E">mdi-leaf</v-icon>
              <span>Our Collection</span>
            </div>
            <h2 class="professional-title" v-if="items._id">
              {{ items._id.name }} <span class="accent-dot">.</span>
            </h2>
          </div>
          <v-btn text color="#3EA56E" class="view-all-btn px-0 hidden-xs-only" @click="goToCategory(items._id)">
            View All <v-icon right size="18">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters v-if="renderCarousel && items.products && items.products.length > 0">
      <v-col cols="12">
        <OwlCarousel
          :key="carouselKey"
          v-bind="owlOptions"
          class="modern-carousel-v2"
        >
          <template v-for="(item, i) in items.products">
            <div :key="i" class="pa-2 h-full">
              <v-hover v-slot="{ hover }">
                <v-card
                  class="premium-product-card"
                  :elevation="hover ? 12 : 0"
                  style="border-radius: 16px; border: 1px solid #f1f5f9; overflow: hidden; display: flex; flex-direction: column; height: 100%; transition: all 0.4s ease;"
                  @click="$router.push('/productdetailview/' + item.urlname)"
                >
                  <!-- Image Section -->
                  <div style="position: relative; background: white; padding: 16px; display: flex; justify-content: center; align-items: center; border-radius: 16px 16px 0 0; overflow: hidden;">
                    <!-- Stock Status -->
                    <div style="position: absolute; top: 12px; left: 12px; z-index: 2; display: flex; flex-direction: column; gap: 6px;">
                      <div v-if="item.status == 'Inactive' || item.quantity < item.minimumOrderQuantity" style="background: #fee2e2; color: #ef4444; font-size: 10px; font-weight: 700; padding: 4px 10px; border-radius: 6px; text-transform: uppercase;">
                        Out of Stock
                      </div>
                      <div v-if="item.price > item.offerPrice" style="background: #3EA56E; color: white; font-size: 10px; font-weight: 700; padding: 4px 10px; border-radius: 6px; text-transform: uppercase;">
                        {{ Math.round(((item.price - item.offerPrice) / item.price) * 100) }}% OFF
                      </div>
                    </div>
                    
                    <v-img
                      v-if="item.photos && item.photos.length > 0"
                      :src="mediaURL + item.photos[0]"
                      height="200"
                      contain
                      class="product-visual"
                      style="transition: transform 0.5s ease; cursor: pointer;"
                    >
                      <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                          <v-progress-circular indeterminate color="#3EA56E" size="24"></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      src="../../assets/Images/noimage.png"
                      height="200"
                      contain
                      class="product-visual"
                    ></v-img>
                  </div>

                  <!-- Info Section -->
                  <v-card-text class="pa-4 text-left d-flex flex-column" style="flex-grow: 1;">
                    <!-- Category Tag with Leaf Icon -->
                    <!-- <div style="display: inline-flex; align-items: center; background: rgba(62, 165, 110, 0.08); padding: 4px 12px; border-radius: 20px; font-size: 11px; font-weight: 600; color: #3EA56E; margin-bottom: 12px; align-self: flex-start;">
                      <v-icon left size="14" color="#3EA56E">mdi-leaf</v-icon>
                      <span v-if="items._id">{{ items._id.name }}</span>
                      <span v-else>Product</span>
                    </div> -->

                    <!-- Title -->
                    <h3 style="  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 10px;

  width: 100%;
  display: block;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;">
                      {{ item.productname }}
                    </h3>

                    <!-- Rating -->
                    <div style="display: flex; align-items: center; margin-bottom: 8px;">
                      <v-rating v-model="item.rating" background-color="#E2E8F0" color="#F59E0B" dense readonly size="16" half-increments></v-rating>
                      <span class="review-stats ml-2" v-if="item.totalReviews > 0" style="font-size: 12px; color: #94a3b8;">
                        {{ item.totalReviews }} reviews
                      </span>
                    </div>

                    <div style="flex-grow: 1;"></div>

                    <!-- Price -->
                    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 16px;">
                      <div style="font-size: 20px; font-weight: 700; color: #3EA56E;">
                        ₹{{ item.offerPrice }} 
                        <span v-if="item.unit" style="font-size: 13px; font-weight: 500; color: #64748b;">/ {{ item.unit }}</span>
                      </div>
                      <div v-if="item.price > item.offerPrice" style="font-size: 14px; color: #94a3b8; text-decoration: line-through;">
                        ₹{{ item.price }}
                      </div>
                    </div>

                    <!-- Actions -->
                    <div style="display: flex; gap: 12px; align-items: center; margin-top: auto;">
                      <v-btn 
                        v-if="!item.incart"
                        depressed 
                        color="#3EA56E" 
                        dark 
                        style="flex: 1; border-radius: 8px; text-transform: none; font-weight: 600; font-size: 14px; height: 40px;"
                        @click.stop="addToCart(item._id)"
                        :disabled="item.quantity < item.minimumOrderQuantity"
                      >
                        <v-icon left size="20">mdi-cart-outline</v-icon>
                        Add to Cart
                      </v-btn>
                      
                      <v-btn 
                        v-if="item.incart"
                        depressed 
                        color="#3EA56E" 
                        dark 
                        style="flex: 1; border-radius: 8px; text-transform: none; font-weight: 600; font-size: 14px; height: 40px;"
                        @click.stop="$router.push('/cart')"
                      >
                        <v-icon left size="20">mdi-check</v-icon>
                        In Cart
                      </v-btn>

                      <v-btn 
                        icon 
                        outlined 
                        :color="item.inWishlist || item.inwishlist ? '#ef4444' : '#e2e8f0'" 
                        style="border: 1px solid #e2e8f0; border-radius: 8px; width: 40px; height: 40px;"
                        @click.stop="toggleWishlist(item)"
                      >
                        <v-icon size="20" :color="item.inWishlist || item.inwishlist ? '#ef4444' : '#64748b'">{{ item.inWishlist || item.inwishlist ? 'mdi-heart' : 'mdi-heart-outline' }}</v-icon>
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-hover>
            </div>
          </template>
        </OwlCarousel>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["title", "items"],
  data() {
    return {
      renderCarousel: true,
      carouselKey: 0,
      owlOptions: {
        nav: false,
        dots: true,
        loop: false,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,

        responsive: {
          0: { items: 1, margin: 10, nav: false },
          600: { items: 2, margin: 15, nav: false },
          960: { items: 3, margin: 20, nav: false },
          1264: { items: 4, margin: 24, nav: false },
          1600: { items: 5, margin: 24, nav: false },
        },
      },
    };
  },
  watch: {
    items: {
      deep: true,
      handler() {
        this.renderCarousel = false;
        this.$nextTick(() => {
          this.renderCarousel = true;
          this.carouselKey++;
        });
      }
    }
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
  },
  methods: {
    goToCategory(cat) {
      if (!cat) return;
      this.$store.commit("updateMainCatId", cat._id);
      localStorage.setItem("mainCategory", cat._id);
      this.$store.commit("updateCatId", "");
      this.$store.commit("updateSubCatId", "");
      this.$router.push("/products/" + cat.urlname);
    },
toggleWishlist(item) {
  const inWishlist = item.inWishlist || item.inwishlist;
  const url = inWishlist ? "/WishList/Remove" : "/WishList/Addorupdate";

  var headers1 = {};
  var data = {
    productid: item._id
  };

  if (this.appLogin) {
    headers1 = {
      "x-auth-token": localStorage.getItem("token"),
    };
  } else {
    data["guestid"] = localStorage.getItem("guestId");
  }

  axios({
    method: "POST",
    url: url,
    data: data,
    headers: headers1,
  })
  .then((response) => {
    if (response.data.status) {
      this.$set(item, 'inWishlist', !inWishlist);
      this.$set(item, 'inwishlist', !inWishlist);
      this.$store.commit("changeWishlist", response.data.wishlistcount);
    }
  })
  .catch(console.log);
},
    addToCart(item) {
      var headers1 = {};
      var data = { productId: item, quantity: 1 };
      if (this.appLogin) {
        headers1 = { "x-auth-token": localStorage.getItem("token") };
      } else {
        data["guestid"] = localStorage.getItem("guestId");
      }
      
      axios({
        method: "post",
        url: "/cart/add",
        data: data,
        headers: headers1,
      })
        .then((response) => {
          if (response.data.status == true) {
            this.$emit("stepper", { ref: "callgetdata", getdata: true });
            this.$store.commit("changeCart", response.data.cartLength);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.exclusive-container {
  margin-bottom: 40px;
}

.owl-nav {
  display: none !important;
}

/* Header Styling */
.premium-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(62, 165, 110, 0.08);
  padding: 4px 12px;
  border-radius: 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #3EA56E;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.professional-title {
  font-family: 'Poppins', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.5px;
}

.accent-dot {
  color: #3EA56E;
}

.view-all-btn {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
}

.view-all-btn:hover {
  background: transparent !important;
  transform: translateX(4px);
}

/* Product Card Styling */
.premium-product-card {
  border-radius: 16px !important;
  border: 1px solid #f1f5f9 !important;
  background: white !important;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.premium-product-card:hover {
  transform: translateY(-8px);
  border-color: transparent !important;
}

.card-image-section {
  position: relative;
  background: #f8fafc;
  border-radius: 16px 16px 0 0;
  padding: 24px;
  overflow: hidden;
}

.product-visual {
  transition: transform 0.5s ease;
}

.premium-product-card:hover .product-visual {
  transform: scale(1.08);
}



.card-badges {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stock-status {
  font-size: 10px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stock-status.out { background: #fee2e2; color: #ef4444; }
.stock-status.discount { background: #3EA56E; color: white; }

.cat-tag {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
}

.product-title-text {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
  height: 42px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.review-stats {
  font-size: 12px;
  color: #94a3b8;
}

.price-block {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

.main-price {
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
}

.currency { font-size: 14px; margin-right: 2px; }
.per-unit { font-size: 12px; font-weight: 500; color: #64748b; }

.original-price {
  font-size: 14px;
  color: #94a3b8;
  text-decoration: line-through;
}

.card-footer {
  border-top: 1px solid #f1f5f9;
}

/* Modern Dot Pagination */
.modern-carousel-v2 ::v-deep .owl-dots {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 28px;
  padding: 0;
}

.modern-carousel-v2 ::v-deep .owl-dots .owl-dot {
  outline: none;
}

.modern-carousel-v2 ::v-deep .owl-dots .owl-dot span {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #cbd5e1;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  margin: 0;
}

.modern-carousel-v2 ::v-deep .owl-dots .owl-dot.active span {
  width: 28px;
  background: #3EA56E;
}

.modern-carousel-v2 ::v-deep .owl-dots .owl-dot:not(.active) span:hover {
  background: #94a3b8;
}

@media (max-width: 600px) {
  .professional-title { font-size: 20px; }
  .card-image-section { padding: 12px; }
  .product-title-text { font-size: 13px; height: 36px; }
  .main-price { font-size: 16px; }
  .premium-cart-btn { height: 38px !important; font-size: 12px; }
}
</style>